import React from 'react';
import CacheBuster from 'react-cache-buster';
import { ConfirmProvider } from "material-ui-confirm";
// import { useIdleTimer } from 'react-idle-timer';
import { version } from '../package.json';
// routes
import Router from './routes/index';
// theme
import ThemeConfig from './theme';
// hooks
import useAuth from './hooks/useAuth';

// components
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import GoogleAnalytics from './components/GoogleAnalytics';
import HalloweenTheme from './components/halloween/HalloweenTheme';
import NotistackProvider from './components/NotistackProvider';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import ThemeLocalization from './components/ThemeLocalization';
// ----------------------------------------------------------------------


export default function App() {
  const { isInitialized,
    // logout 
  } = useAuth();
  // const { pathname, search } = useLocation();
  // const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));

  // context
  // const { getCompanySettings, favIconLogo, setHeaderLogo, headerLogo } = useAuth();

  // const onIdle = () => {
  // const obj = { pathLink: `${pathname}${search}`, email: loggedUserData?.email }
  // localStorage.setItem('lastPath', JSON.stringify(obj));
  //   logout();
  // }

  // const THIRTY_MINUTES = 30 * 60 * 1000;

  // const idleTimer = useIdleTimer({
  //   onIdle,
  //   timeout: THIRTY_MINUTES, 
  //   crossTab: true,
  //   syncTimers: true,
  //    events: [
  //   'mousemove',
  //   'keydown',
  //   'wheel',
  //   'DOMMouseScroll',
  //   'mousewheel',
  //   'mousedown',
  //   'touchstart',
  //   'touchmove',
  //   'MSPointerDown',
  //   'MSPointerMove',
  //   'visibilitychange'
  //   ],
  // })

  // React.useEffect(() => {
  //   localStorage.removeItem('lastPath');
  //   idleTimer.start();
  // }, [])


  // get fav icon image from api
  // React.useEffect(() => {

  //   if (favIconLogo || headerLogo) {
  //     alert("triggered from app");
  //     const fetchMyAPI = async () => {
  //       const response = await getCompanySettings();
  //       setHeaderLogo(response?.logo);
  //       const favIcon = document.getElementById("favicon");
  //       favIcon.href = response?.favicon;
  //     }

  //     fetchMyAPI();
  //   }

  // }, [favIconLogo, headerLogo]);

  return (
    <>

      <ThemeConfig>
        <ThemePrimaryColor>
          <ConfirmProvider>
            <ThemeLocalization>
              <RtlLayout>
                <NotistackProvider>
                  {/* <Settings /> */}
                  <ScrollToTop />
                  <HalloweenTheme />
                  <GoogleAnalytics />
                  <CacheBuster
                    currentVersion={version}
                    isEnabled
                    // isVerboseMode
                    loadingComponent={<LoadingScreen />}
                  // metaFileDirectory="."
                  >

                    {isInitialized ? <Router /> : <LoadingScreen />}
                  </CacheBuster>
                </NotistackProvider>
              </RtlLayout>
            </ThemeLocalization>
          </ConfirmProvider>
        </ThemePrimaryColor>
      </ThemeConfig>
    </>
  );
}
